module.exports = __webpack_public_path__ + "media/common/images/important-document-icon-92617ec183ef8f77319211c5814d51b4.svg";